import React, { ReactNode } from 'react';
import { GlobalStyleInternal, Main } from '@/layout/LayoutInternal/LayoutInternal.styles';
import { Breadcrumb } from '@/components/breadcrumb';
import { Container } from '@/components/container';
import { Grid } from '@/components/grid';
import Header from '@/components/header';
import { NavbarProps } from '@/components/navbar/Navbar/Navbar';
import DebugFontSize from '@/components/debugger';
import { IS_DEVELOPMENT } from '@/utils/environment';
import FooterSticky from '@/components/footer/FooterSticky';
import Footer from '@/components/footer/Footer';
import WhatsAppFAB from '@/components/button/WhatsAppFAB';
import Popup from '@/components/popup';
import TopScroll from 'src/components/top-scroll';
import Cover from '@/components/banner/Cover/Cover';
import MediaCover from '@/components/media/MediaCover/MediaCover';

export interface LayoutInternalProps {
  cover?: ImageCoverType;
  mediaCover?: MediaCoverType;
  breadcrumbs: BreadcrumbType;
  children?: ReactNode;
  navbar?: NavbarProps['variant'];
  footer?: 'default' | 'sticky';
  section?: ReactNode;
  showWhatsAppDropup?: boolean;
}

const LayoutInternal = ({
  cover,
  mediaCover,
  breadcrumbs,
  children,
  navbar = 'animated',
  footer = 'default',
  section = null,
  showWhatsAppDropup = true,
}: LayoutInternalProps) => {
  return (
    <>
      <GlobalStyleInternal />
      <Header navbar={navbar} />
      <Main sticky={navbar === 'sticky'}>
        {(cover && <Cover cover={cover} />) || null}
        {/*NOTE: undefined means that the layout is not being used by the new Media feature,
        this is to support legacy Cover based on Image obj*/}
        {(mediaCover !== undefined && <MediaCover cover={mediaCover} />) || null}
        <Container position="relative">
          <Grid container>
            <Grid item col={12}>
              <Breadcrumb items={breadcrumbs} />
            </Grid>
            {children}
          </Grid>
        </Container>
        {section}
      </Main>
      {showWhatsAppDropup && <WhatsAppFAB />}
      {(footer === 'sticky' && <FooterSticky />) || <Footer />}
      {(IS_DEVELOPMENT && <DebugFontSize />) || null}
      <Popup />
      {/*<CookieConsent />*/}
      <TopScroll />
    </>
  );
};

export default LayoutInternal;
